export const ColTitle = ({ name }) => {
  return <div className="flex justify-center w-full ">{name}</div>;
};


